<template>
     <div>
      <h1>{{ $t('help.ISAWeeklyReportHelp_title') }}</h1>
      <p class="text-justify">
          {{ $t('When this feature is on, the subscribed users in this care unit will receive a weekly report from the ISA system. You can choose the reception day. Please take into account that the report does not cover the last 2 days.') }}
      </p>
      
    </div>
</template>

<script>

export default  {
  components: {    
  },  
  data() {
    return {      
    }
  },
  watch : {    
  },    
  methods: {        
    },
  mounted() {            
  },
  name: "ISAHelpModalContent"
}
</script>

<style lang="scss" scoped>
h1 {
  font-weight: 700;
}

.modal-title {
  font-weight: 700;
}

</style>
